import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { NAV } from "@/lib/constants";

export default function Footer() {
  const { config, categories } = useSite();
  return (
    <footer className="border-t border-[#27272A] bg-[#0A0A0B]">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-10 px-4 py-16 md:grid-cols-4 lg:px-8">
        <div className="md:col-span-1">
          <img src={config?.logo} alt="Global Refrigeração" className="h-12 w-auto" />
          <p className="mt-4 max-w-xs text-sm text-[#A1A1AA]">
            {config?.tagline || "Equipamentos e Soluções em Refrigeração Industrial"}. Projetamos, dimensionamos, fabricamos, instalamos e prestamos assistência.
          </p>
        </div>
        <div>
          <div className="label-eyebrow mb-4">Equipamentos</div>
          <ul className="space-y-2">
            {categories.slice(0, 8).map((c) => (
              <li key={c.slug}>
                <Link to={`/equipamentos/${c.slug}`} className="text-sm text-[#A1A1AA] transition-colors duration-200 hover:text-[#FF5500]">{c.name}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <div className="label-eyebrow mb-4">Institucional</div>
          <ul className="space-y-2">
            {NAV.map((n) => (
              <li key={n.to}><Link to={n.to} className="text-sm text-[#A1A1AA] transition-colors duration-200 hover:text-[#FF5500]">{n.label}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <div className="label-eyebrow mb-4">Contato</div>
          <ul className="space-y-3 text-sm text-[#A1A1AA]">
            <li className="flex items-start gap-2"><MapPin className="mt-0.5 h-4 w-4 text-[#FF5500]" />{config?.address}</li>
            <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-[#FF5500]" />{config?.phone}</li>
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-[#FF5500]" />{config?.email}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#27272A] px-4 py-6 lg:px-8">
        <div className="mx-auto flex max-w-[1400px] flex-col items-center justify-between gap-2 text-xs text-[#71717A] md:flex-row">
          <span>© {new Date().getFullYear()} {config?.company_name || "Global Refrigeração"}. Todos os direitos reservados.</span>
          <Link to="/admin/login" className="hover:text-[#A1A1AA]" data-testid="footer-admin-link">Área Administrativa</Link>
        </div>
      </div>
    </footer>
  );
}
